<script setup>
  import ComponentPatientSidebarDegreeOfCareAttribute from "@components/Sidebars/PatientSidebar/DegreeOfCareAttribute.vue";
  import ComponentPatientSidebarMobilityAttribute from "@components/Sidebars/PatientSidebar/MobilityAttribute.vue";
  import ComponentPatientSidebarNursingHomeAttribute from "@components/Sidebars/PatientSidebar/NursingHomeAttribute.vue";
  import ComponentPatientSidebarPatientAddressAttribute from "@components/Sidebars/PatientSidebar/PatientAddressAttribute.vue";
  import ComponentPatientSidebarSimpleAttribute from "@components/Sidebars/PatientSidebar/SimpleAttribute.vue";
  import ComponentPatientSidebarTubePatientAttribute from "@components/Sidebars/PatientSidebar/TubePatientAttribute.vue";

  defineOptions({
    name: "PagesRecordResultPatientDataPatientAttributes",
  });

  const props = defineProps({
    patient: {
      type: Object,
      required: true,
    },
  });

  function getComponentName(type) {
    switch (type) {
      case "degreeOfCare":
        return ComponentPatientSidebarDegreeOfCareAttribute;
      case "mobility":
        return ComponentPatientSidebarMobilityAttribute;
      case "nursingHome":
        return ComponentPatientSidebarNursingHomeAttribute;
      case "patientAddress":
        return props.patient.is_fake ? false : ComponentPatientSidebarPatientAddressAttribute;
      case "tubePatient":
        return ComponentPatientSidebarTubePatientAttribute;
      case "insulinPump":
      case "palliativePatient":
      case "port":
      case "stoma":
        return ComponentPatientSidebarSimpleAttribute;
    }
  }
</script>

<template>
  <div
    v-if="patient.patient_attributes.length > 0"
    class="py-2 sm:grid sm:grid-cols-4 sm:gap-4"
    :data-test="getTestId('result-individual-characteristics')"
  >
    <dt class="font-semibold text-gray-900">Individuelle Besonderheiten</dt>

    <dd class="mt-1 text-gray-700 sm:col-span-3 sm:mt-0">
      <ul>
        <template v-for="attribute in patient.patient_attributes" :key="attribute.id">
          <template v-if="attribute.type !== 'patientAddress'">
            <li>
              <component
                :is="getComponentName(attribute.type)"
                :attribute="attribute"
                :patient="patient"
                :inline="true"
              />
            </li>
          </template>
        </template>
      </ul>
    </dd>
  </div>
</template>
